import {
  ECalculationType,
  EMetricType,
  EOccurrenceType,
  EPairType,
  EWithinUnitType,
} from '../types/enum';

export enum EMetricTypes {
  DURATION,
  CONVERSION,
  SINGLE_EVENT,
  RATIO_METRIC = 5,
}

export enum EEventType {
  // Flow
  START_EVENT = 'start_event',
  SUCCESS_EVENT = 'success_event',
  WITHOUT_EVENT = 'without_event',
  ERROR_EVENT = 'error_event',
  // Metric
  FIRST_EVENT = 'first_event',
  SECOND_EVENT = 'second_event',
  // Single event metric
  EVENT = 'event',
}

export interface IDefinition {
  calculation: ECalculationType;
  first_event: number;
  second_event: number;
  within_unit?: EWithinUnitType;
  within_range?: number;
  distribution?: {
    max_value?: number;
    min_value?: number;
  };
  need_distribution: 1 | 0;
  occurrence_type?: EOccurrenceType;
  pairing_logic?: EPairType;
  complete_timeout?: number;
  complete_timeout_unit?: EWithinUnitType;
}

export interface IMetric {
  customer_id: number;
  id: number;
  name: string;
  description: string;
  metrics_type: EMetricType;
  status: number;
  related_events: number[];
  updated_at: number;
  created_at: number;
  deployed_at: number;
  definition: IDefinition;
  metric_category: number;
  use_case_metric_id: number;
  is_ever_deployed: number;
  is_beta?: boolean;
}

export interface IMetricInit
  extends Omit<
    IMetric,
    'id' | 'created_at' | 'updated_at' | 'deployed_at' | 'related_events' | 'status' | 'customer_id'
  > {
  id?: number;
  created_at?: number;
  updated_at?: number;
  deployed_at?: number;
  related_events?: string[];
  status?: number;
  customer_id?: number;
}

export type MetricDataScope = 'event_summary' | 'service_flow';
export interface CalculableMetric {
  id: number;
  is_predefined: number;
  name: string;
  target_scope: Array<MetricDataScope>;
}
